module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic5-300x208.3686dfbc.png";